export const MessageGroup: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col space-y-1 pb-4">
      {children}
    </div>
  );
};
